import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import Loader from './Loader'

import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import InstaTable from './InstaTable'

import {
  users_index,
  skills_index,
  businesses_index,
  reset_user,
  clear_user,
  lock_user,
  users_xlsx,
  unlock_user,
  resend_invitation,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.user
  return {
    user: state.user,
    users: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
    skills: state.skill.items,
    businesses: state.business.items,
    setStatus: state.user.set_status
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getUsers: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( users_index(page, per_page, filters, sort, order) ),
    usersXLSX: (filters, sort, order, variant) => dispatch ( users_xlsx(filters, sort, order, variant) ),
    lockUser: (user_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(lock_user(user_id, index, page, per_page, filters, sort, order)),
    unlockUser: (user_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(unlock_user(user_id, index, page, per_page, filters, sort, order)),
    resendInvitation: (user_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(resend_invitation(user_id, index, page, per_page, filters, sort, order)),
    resetUser: () => dispatch( reset_user() ),
    clearUser: () => dispatch( clear_user() ),
    getSkills: () => dispatch( skills_index() ),
    getBusinesses: () => dispatch( businesses_index() ),

  }
}

class ConnectedUsersIndex extends React.Component {
  state={
    current_user: null,
    current_view: 'all',
    merge_filters: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    const { active, locked, confirmed } = item
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters,
        type: this.props.userbase,
      }
    }
    let renderText
    if (field === "created_at" || field === "updated_at") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if ( field === "status" ) {
      let theStatus
      if ( active && !locked && confirmed) {
        theStatus = "active"
      } else if ( locked ) {
        theStatus = "locked"
      } else if ( !confirmed ) {
        theStatus = "pending"
      } else if ( !active && confirmed ) {
        theStatus = "revoked"
      }
      renderText = this.statusIcon(theStatus)
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === 'pq') {
      renderText = item.questions ? item.questions.published : 0
    } else if (field === 'dq') {
      renderText = item.questions ? item.questions.draft : 0
    } else if (field === 'tq') {
      renderText = item.questions ? item.questions.trash : 0
    } else if (field === 'tests_taken') {
      renderText = item.tests_taken ? item.tests_taken : 0
    } else if (field === 'total_paid' ) {
      renderText = `${item[field].toFixed(2)} €`
    } else if (field === 'name') {
      renderText = (
        <div>
          <div className="td-user-email">{item.email}</div>
          <div className="td-user-name">{item.name} {item.surname}</div>
        </div>
      )
    } else if (field === 'skill') {
      renderText = item.skill ? item.skill.name : ''
    } else if (field === 'business') {
      renderText = item.business ? item.business.name : ''
    } else if (field === 'role') {
      const roles = {
        expert: "Skill Expert",
        admin: "Global Administrator",
        creator: "Data Content Creator",
        client: "B2B Account"
      }
      renderText = roles[item.role]
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          {this.editLink(item)}
          {((active && locked) || (!active && confirmed)) && this.unlockLink(item, state)}
          {(active) && this.lockLink(item, state)}
          {(!confirmed) && this.resendLink(item, state)}
          { this.props.userbase === 'user' ? this.resultsLink(item) : '' }
          { this.props.userbase === 'system' ? this.questionsLink(item) : '' }
          { this.props.userbase === 'user' ? this.purchasesLink(item) : '' }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getUsers, getSkills, getBusinesses, userbase} = this.props
    let initFilters = {
      ...this.state.merge_filters,
      type: this.props.userbase || ""
    }

    if (this.props.location && this.props.location.state && this.props.location.state.business) {
      initFilters = {
        ...initFilters,
        business: this.props.location.state.business
      }
    }
    this.setState({initFilters: initFilters})

    getUsers(1, 10, initFilters, '', '')

    if (userbase === 'user' || userbase === 'b2b') {
      getBusinesses()
    } else if (userbase === 'system') {
      getSkills()
    }
  }

  componentWillUnmount() {
    this.props.resetUser()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (!this.props.user.fetching && this.props.user.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  editLink = item => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = item
      return (
        <Link to={`/users/${id}/edit`} className="action-btn" title="Edit">
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>create</Icon>
        </Link>
      )
    } else {
      return ''
    }
  }

  unlockLink = (item, state) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = item
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Unlock User" onClick={e=>{
          e.preventDefault()
          this.props.unlockUser(id, true,  page, per_page, filters, sort, order)
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>lock_open</Icon>
        </Link>
      )
    }
    return ''
  }

  lockLink = (item, state) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = item
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Block" onClick={e=>{
          e.preventDefault()
          this.props.lockUser(id, true,  page, per_page, filters, sort, order)
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>block</Icon>
        </Link>
      )
    }
    return ''
  }

  resendLink = (item, state) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = item
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Resend Invitation" onClick={e=>{
          e.preventDefault()
          this.props.resendInvitation(id, true,  page, per_page, filters, sort, order)
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>mail</Icon>
        </Link>
      )
    }
    return ''
  }

  headerButton = (filters, sort, order) => {
    const all_filters = {
      ...filters,
      type: this.props.userbase
    }
    return (
      <Hidden smDown>
        <a href='' style={{float: 'right'}} onClick={e => {
          e.preventDefault()
          this.props.usersXLSX(all_filters, sort, order, this.props.userbase)
        }}>
          Download XLSX
        </a>
      </Hidden>
    )
  }

  hideDialog() {
    this.setState({showDialog: false, showPreview: false, current_template: {}})
  }

  statusIcon = status => {
    if (status === 'active') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Active">person_outline</Icon>
    } else if (status === 'locked') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Locked Out">lock</Icon>
    } else if (status === 'pending') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Pending">hourglass_empty</Icon>
    } else if (status === 'revoked') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Blocked">block</Icon>
    }
  }

  showPreview = user => {
    this.setState({showPreview: true, current_template: user})
  }

  resultsLink = (user) => {
    const {current_user} = this.props
    if (current_user.role === "admin" || current_user.role === 'expert') {
      const {email} = user
      return (
        <Link to={`/tests/user?user=${email}`} className="action-btn" title="Test Results" target="_blank">
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>insert_chart</Icon>
        </Link>
      )
    }
    return ''
  }

  questionsLink = (user) => {
    const {current_user} = this.props
    if (current_user.role === "admin" || current_user.role === 'expert') {
      const {longid} = user
      return (
        <Link to={`/questions/user?user=${longid}`} className="action-btn" title="User Questions" target="_blank">
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>folder_open</Icon>
        </Link>
      )
    }
    return ''
  }

  purchasesLink = (user) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {email} = user
      return (
        <Link to={`/purchases/user?user=${email}`} className="action-btn" title="User Purchases" target="_blank">
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>euro_symbol</Icon>
        </Link>
      )
    }
    return ''
  }


  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( ["admin"].indexOf(role) < 0 ) {
      return <Redirect to="/" />
    }

    const { pagination, skills, businesses, users, totals } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const roles = [
      {name: "Global Administrator", id: "admin"},
      {name: "Skill Expert", id: "expert"},
      {name: "Data Content Creator", id: "creator"},
    ]

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'role', disablePadding: true, label: 'Role', visible: "system" },
      { id: 'skill', disablePadding: true, label: 'Skill', requires: ['admin'], visible: "system" },
      { id: 'name', disablePadding: true, label: 'User' },
      { id: 'business', disablePadding: true, label: 'Business', visible: "b2b" },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'created_at', disablePadding: true, label: 'Creation Date' },
      { id: 'tests_taken', disablePadding: true, label: 'Tests Taken', requires: ['admin'], visible: "user" },
      { id: 'total_paid', disablePadding: true, label: 'Total Purchases', requires: ['admin'], visible: "user" },
      { id: 'pq', disablePadding: true, label: 'Published Qs', requires: ['admin'], visible: "system" },
      { id: 'dq', disablePadding: true, label: 'Draft Qs', requires: ['admin'], visible: "system" },
      { id: 'tq', disablePadding: true, label: 'Trashed Qs', requires: ['admin'], visible: "system" },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true, requires: ['admin'] },
    ].filter(
      c => c.requires === undefined || c.requires.indexOf(role) > -1
    ).filter(
      c => c.visible === undefined || c.visible === this.props.userbase
    )

    const filterControls = [
      { name: "role", filter_type: "select", valueField: "name", collection: roles, visible: "system" },
      { name: "skill", filter_type: "select", valueField: "name", collection: skills, visible: "system" },
      { name: "business", filter_type: "select", valueField: "name", collection: businesses, visible: "b2b" },
      { name: "business", filter_type: "select", valueField: "name", collection: businesses, visible: "user" },
      { name: "search", filter_type: "search" },
      { name: "created_at", filter_type: "date" },
    ].filter(
      c => c.requires === undefined || c.requires.indexOf(role) > -1
    ).filter(
      c => c.visible === undefined || c.visible === this.props.userbase
    )

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "active", label: "Active", value: totals.active },
      { name: "locked", label: "Locked", value: totals.locked },
      { name: "pending", label: "Pending", value: totals.pending },
      { name: "revoked", label: "Blocked", value: totals.revoked },
    ]

    return (
      <div id="users-wrapper" className={this.props.user.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            {this.props.header}
          </Typography>

          <CustomOutlinedButton
            component={Link}
            to="/users/new"
            className="buttonnoto c-blue align-self-center">
            Add User
          </CustomOutlinedButton>

        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={users}
          pagination={pagination}
          search={true}
          placeholders={this.props.userbase === "b2b" ? "ID, name, email, business" : "ID, name, email"}
          role={role}
          merge_filters={{
            ...this.state.merge_filters,
            type: this.props.userbase,
          }}
          init_filters={this.state.initFilters}
          rowGetter={this.props.getUsers.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          previewColumn=""
          clearItem={this.props.clearUser.bind(this)}
          previewItem={this.showPreview.bind(this)}
          headerButton={this.headerButton.bind(this)}
          classPrefix="user"
          addClassField="status"
        />

        {
          // <CustomDialog
          //   id="delete-dialog"
          //   fullScreen = {false}
          //   qid={this.state.current_id}
          //   isopen={this.state.showDialog}
          //   handleClose={this.hideDialog.bind(this)}
          //   handleAccept={this.destroy.bind(this)}
          //   title="Delete Template?"
          // >
          //   This action cannot be undone
          // </CustomDialog>
          // <TemplatePreview
          //   id="preview-template-dialog"
          //   isopen={this.state.showPreview}
          //   template={this.state.current_template}
          //   handleClose={this.hideDialog.bind(this)}
          // />
        }

      </div>
    )
  }
}

const UsersIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedUsersIndex)

export default withStyles(styles)(UsersIndex)



// WEBPACK FOOTER //
// ./src/js/components/UsersIndex.js